import Icon from '../components/Icon.vue'

Icon.register({
  hiking: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M81 472.2C76.7 489.4 87.1 506.8 104.2 511 106.8 511.7 109.5 512 112 512 126.4 512 139.4 502.3 143.1 487.8L168.3 386.8 115.5 334 81 472.2zM95.8 276.1L137 117C139.2 108.6 133.9 100.1 125.1 97.9 81.2 87.4 36.7 113 25.8 155.1L0.5 253.2C-1.7 261.7 3.6 270.2 12.4 272.3L76 287.6C84.8 289.6 93.7 284.5 95.8 276.1zM368 160H352C343.2 160 336 167.2 336 176V192H301.3L254.5 145.2C243.4 134.1 228.6 128 212.9 128 185.9 128 162.4 146.3 155.9 172.5L129 280.2A32-32 0 0 1 137.4 310.6L224 397.3V480C224 497.7 238.3 512 256 512S288 497.7 288 480V397.3C288 380.2 281.3 364.1 269.3 352L222.4 305.2C222.6 304.7 222.9 304.3 223.1 303.8L242.9 224.2 265.4 246.6C271.4 252.6 279.5 256 288 256H336V496C336 504.9 343.2 512 352 512H368C376.8 512 384 504.9 384 496V176C384 167.2 376.8 160 368 160zM240 96C266.5 96 288 74.5 288 48S266.5 0 240 0 192 21.5 192 48 213.5 96 240 96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hiking.js
// module id = Hoso
// module chunks = 144